<div *ngIf="showArrow" class="tooltip-arrow"></div>
<div @tooltip class="tooltip">
  <ng-container *ngIf="tooltipText">
    <span class="tooltip-text">{{ tooltipText }}</span>
  </ng-container>
  <ng-container *ngIf="!tooltipText">
    <ng-container *ngTemplateOutlet="tooltipTemplate; context: tooltipTemplateContext"></ng-container>
  </ng-container>
</div>
